import { useScriptTag } from "@vueuse/core";
import useThirdPartyScriptEndpoints from "@/composables/api/useThirdPartyScriptEndpoints";

const { getSiftData } = useThirdPartyScriptEndpoints();

export default () => {
  const useSiftScript = async () => {
    const { session_id, user_id, sift_beacon_key } = await getSiftData();

    window._sift = window._sift || [];
    window._sift.push(["_setAccount", sift_beacon_key]);
    window._sift.push(["_setUserId", user_id]);
    window._sift.push(["_setSessionId", session_id]);
    window._sift.push(["_trackPageview"]);

    const loadSift = () => {
      useScriptTag("https://cdn.sift.com/s.js");
    };

    if (window.attachEvent) {
      window.attachEvent("onload", loadSift);
    } else {
      window.addEventListener("load", loadSift, false);
    }
  };

  return {
    useSiftScript,
  };
};
